/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery, disable } from '@insticator/insticator-ui'; // iui-utils
import { themeV2 } from 'utils/themeV2';



// ********* HELPERS ********* //
const embedPropertiesThinStyles = {
	width: pxToEm(150),
	'& .currentcolor': {
	    display: 'flex',
	    alignItems: 'stretch',
	    justifyContent: 'flex-start',
	    flexWrap: 'wrap'
	},
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(130)} !important`,
		}
	},
	'& .note': {
		'& span': {
			display: 'inline !important'
		}
	}
};
const embedPropertiesThinnestStyles = {
	width: '100%',
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(200)} !important`,
		}
	},
	'& .cropContainer': {
		marginBottom: pxToEm(30),
	},
	'& .note': {
		'& span': {
			display: 'inline !important'
		}
	}
};



/* ++++++++++ --------------- EXPORT : EMBED PROPERTIES : STYLES --------------- ++++++++++ */
export default theme => ({
	embedproperties: {
		position: 'relative',
		width: pxToEm(252),
		minHeight: pxToEm(210),
		textAlign: 'left',
		'& .controllercontainer': {
			marginBottom: pxToEm(10),
			'& .note': {
				marginBottom: pxToEm(8),
				'& span': {
					display: 'block'
				}
			},
		},
		'& .name-embedproperttitle':{
			marginBottom: pxToEm(24),
			'& h4':{
				fontSize: pxToEm(14),
				fontWeight: 'bold'
			}
		},
		'& .property': {
			marginBottom: pxToEm(24),
			'&:last-child': { marginBottom: '0', paddingBottom: '0', borderBottom: 'none', marginTop: pxToEm(18), },
			'& .proptitle': {
				margin: `${pxToEm(5)} 0`,
				'& h5': {
					extend: theme.typography.size.xxsmall
				},
				'& .titleToggle': {
					display: 'flex',
					alignItems: 'center',
					marginBottom: pxToEm(5),
					'& .toggle': {
						marginLeft: pxToEm(10),
						fontSize: '50%'
					}
				},
				'& .switch':{
					margin: `0 ${pxToEm(12)}`
				}
			},
			'& .propdetails': {
				'& .propdetail': {
					display: 'flex',
					flexWrap: 'nowrap',
					justifyContent: 'flex-start',
					marginBottom: pxToEm(24),
					textAlign: 'left',
					'&:last-child': {
						marginBottom: '0'
					},
					'&.image':{
						marginBottom: pxToEm(24)
					}
				},
				transition: 'filter 1s, opacity 1s'
			},
			'&.partnerlogo': {
				'& .propdetail.image': {
					'& .imagedisplay': {
						// width: pxToEm(110),
						height: pxToEm(32)
					}
				},
				'& .propdetail.link': {
					'& .field': {
						width: '100%',
					}, 
					'& .formelement, .icon': {
						height: pxToEm(32)
					}
				}
			},
			'&.insticatorbranding': {
				display: 'flex',
				alignItems: 'center',
				'& .togglelabel':{
					display: 'flex',
					flexWrap: 'wrap',
					fontSize: pxToEm(12),
					fontWeight: '500'
				},
				'& .toggle': {
					marginLeft: pxToEm(15),
					fontSize: '50%'
				}
			}
		},
		'& .noPartnerLogo': {
			extend: disable
		},
		'& .textfield':{
			fontFamily: `${theme.typography.font} !important`,
		},
		// ..... PICKER ..... //
		'& .picker': {
			top: 0,
			'& .sketch-picker': {
				width: `${pxToEm(228.8)} !important`,
				borderRadius: '0 !important'
			}
		},
		//Image uploader component styles
		'& .imageupload': {
			width: '100%',
			'& .imagedisplay': {
				background: 'rgba(6, 43, 117, .05)',
				width: '100%', //pxToEm(70),
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: pxToEm(4),
				cursor: 'pointer',
				transition: 'filter .2s linear 0s',
				'&:hover': {
					filter: 'brightness(93%)'
				},
				'& .imageInput': {
					cursor: 'pointer',
					fontSize: pxToEm(16),
					position: 'absolute',
					zIndex: "0",
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					'& p': {
						color: theme.color.primary.medium.swatch,
					}
				}
			},
			//image uploader cropper
			'& .mainImageInput': {
				height: pxToEm(40),
				width: pxToEm(150),
				opacity: "0",
				overflow: 'hidden',
				zIndex: "1",
				cursor: 'pointer',
			},
			'& .cropperSlider': {
				padding: pxToEm(10),
				position: 'absolute',
				zIndex: 3,
				top: 5,
				bottom: pxToEm(15),
				backgroundColor: theme.color.light.light.swatch,
				height: 'fit-content',
				boxShadow: theme.boxShadow.small,
				'& .cropperTitle': {
					marginBottom: pxToEm(5),
					textAlign: 'left',
					fontSize: pxToEm(12)
				},
				'& .cropContainer': { 
					textAlign: 'center',
					marginBottom: pxToEm(50),
					'& canvas': {
						height: pxToEm(150),
						width: pxToEm(200),
						background: themeV2.color.base.gray.primary
					},
				},
				'& .controls': { 
					paddingRight: pxToEm(20)
				},
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: { 
		embedproperties: {
			extend: embedPropertiesThinnestStyles,
		}
	},
	[mediaQuery.customizeRailThin]: { 
		embedproperties: {
			'&.rail': { extend: embedPropertiesThinStyles },
			'& .cropperSlider': {
				right: 0
			}
		}
	},
	[mediaQuery.customizeInContentThin]: { 
		embedproperties: {
			'&.incontent': { extend: embedPropertiesThinStyles }
		}
	}
});
